"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.memoizeFunction = void 0;
const common_1 = require("./common");
const DICTIONARY = {};
function createNode() {
    return {
        map: new WeakMap()
    };
}
function normalizeArg(val) {
    if (common_1.isObject(val) || common_1.isArray(val) || common_1.isFunction(val)) {
        return val;
    }
    if (!DICTIONARY[val]) {
        DICTIONARY[val] = { val };
    }
    return DICTIONARY[val];
}
function memoizeFunction(callback, maxCacheSize = 20) {
    let rootNode = createNode();
    let cacheSize = 0;
    return function memoizedFunction(...args) {
        let currentNode = rootNode;
        if (maxCacheSize > 0 && cacheSize > maxCacheSize) {
            currentNode = rootNode = createNode();
            cacheSize = 0;
        }
        args.forEach((rawArg) => {
            let arg = normalizeArg(rawArg);
            if (!currentNode.map.has(arg)) {
                currentNode.map.set(arg, createNode());
            }
            currentNode = currentNode.map.get(arg);
        });
        if (!currentNode.hasOwnProperty('value')) {
            currentNode.value = callback(...args);
            cacheSize++;
        }
        return currentNode.value;
    };
}
exports.memoizeFunction = memoizeFunction;
//# sourceMappingURL=memoize.js.map